import { Task } from '@repo/shared';
import { z } from 'zod';

export const leaderboardFiltersSchema = z.object({
  datasetIds: z.array(z.string()),
  task: z.nativeEnum(Task),
});

export type LeaderboardFiltersSchema = z.infer<typeof leaderboardFiltersSchema>;
